"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Global error:", error);
  }, [error]);

  return (
    <html lang="th">
      <body className="font-aphonda">
        <main className="min-h-screen bg-white flex items-center justify-center">
          <div className="text-center px-4">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">
              เกิดข้อผิดพลาด
            </h1>
            <p className="text-gray-600 mb-6">กรุณาลองใหม่อีกครั้ง</p>
            <div className="flex gap-4 justify-center">
              <button
                onClick={() => reset()}
                className="bg-[#e4002b] text-white px-6 py-3 rounded-sm font-semibold hover:opacity-90 transition-opacity"
              >
                ลองใหม่
              </button>
              <a
                href="/"
                className="border border-[#e4002b] text-[#e4002b] px-6 py-3 rounded-sm font-semibold hover:opacity-90 transition-opacity"
              >
                กลับหน้าหลัก
              </a>
            </div>
          </div>
        </main>
      </body>
    </html>
  );
}
